<script lang="ts">
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import { debounce } from "lodash";
	import { damageTypeOptionsSelect } from "../../utils/options";
	import { initPage } from "../../store/store";

	export let handleSortBy;
	export let handleSearchBooking;
	export let bookingStatus = false;

	let input;
	let sortBy;
	let sortDir;
	let damageType;
	let status;
	let hasIssues: boolean = false;
	let sortByOptions = [
		{ value: "issue_no", label: "Issue No." },
		{ value: "status", label: "Status" },
		{ value: "date_reported", label: "Date Reported" },
		{ value: "summary", label: "Summary" },
	];

	function handleChange(e) {
		if (bookingStatus) {
			initPage.set(1);
			handleSearchBooking(status, sortDir, hasIssues);
		} else {
			handleSortBy(sortBy, damageType, sortDir, input);
		}
	}

	const handleInput = debounce(() => {
		handleSortBy(sortBy, damageType, sortDir, input);
	}, 500);
</script>

<Row class="my-3">
	<Col class="d-flex justify-content-start" xs={12}>
		{#if bookingStatus}
			<div class="">
				<label for="booking-status-filter" class="visually-hidden"
					>Filter by status</label
				>
				<select
					id="booking-status-filter"
					class="form-select getgo select"
					bind:value={status}
					on:change={() => handleChange("sortBy")}
				>
					<option value=""> All Status</option>
					<option value="-1"> Pending</option>
					<option value="0"> Confirmed</option>
					<option value="1"> Ongoing</option>
					<option value="2"> Cancelled</option>
					<option value="3">Admin Cancelled</option>
					<option value="4">Completed</option>
				</select>
			</div>

			<div class="ms-2">
				<label for="booking-type-filter" class="visually-hidden"
					>Filter by booking type</label
				>
				<select
					id="booking-type-filter"
					class="form-select getgo select"
					bind:value={hasIssues}
					on:change={() => handleChange("hasIssues")}
				>
					<option value={false}> All bookings</option>
					<option value={true}>Bookings with issues </option>
				</select>
			</div>

			<div class="ms-2">
				<label for="booking-sort-dir" class="visually-hidden"
					>Sort direction</label
				>
				<select
					id="booking-sort-dir"
					class="form-select getgo select"
					bind:value={sortDir}
					on:change={() => handleChange("sortDir")}
				>
					<option value="desc"> Descending </option>
					<option value="asc"> Ascending </option>
				</select>
			</div>
		{:else}
			<div
				class="mx-2 position-relative col-4"
				style="margin-left: 0px !important;"
			>
				<label for="issue-search" class="visually-hidden"
					>Search by issue no.</label
				>
				<input
					id="issue-search"
					type="text"
					style="padding-left: 40px !important; box-sizing: border-box;"
					class="form-control getgo input search-icon"
					placeholder=" Search by issue no."
					bind:value={input}
					on:input={handleInput}
				/>
			</div>
			<div class="">
				<label for="issue-sort-by" class="visually-hidden"
					>Sort by</label
				>
				<select
					id="issue-sort-by"
					class="form-select getgo select"
					bind:value={sortBy}
					on:change={() => handleChange("sortBy")}
				>
					<option value="" disabled> Sort by</option>
					{#each sortByOptions as option}
						<option value={option.value}> {option.label}</option>
					{/each}
				</select>
			</div>

			<div class="ms-2">
				<label for="issue-damage-type" class="visually-hidden"
					>Filter by damage type</label
				>
				<select
					id="issue-damage-type"
					class="form-select getgo select"
					bind:value={damageType}
					on:change={() => handleChange("damageType")}
				>
					{#each damageTypeOptionsSelect as option}
						<option value={option.value}> {option.label}</option>
					{/each}
				</select>
			</div>

			<div class="ms-2">
				<label for="issue-sort-dir" class="visually-hidden"
					>Sort direction</label
				>
				<select
					id="issue-sort-dir"
					class="form-select getgo select"
					bind:value={sortDir}
					on:change={() => handleChange("sortDir")}
				>
					<option value="desc"> Descending </option>
					<option value="asc"> Ascending </option>
				</select>
			</div>
		{/if}
	</Col>
</Row>
